"use client";

// src/popper.tsx
import _defineProperty from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["__scopePopper", "virtualRef"],
  _excluded2 = ["__scopePopper", "side", "sideOffset", "align", "alignOffset", "arrowPadding", "avoidCollisions", "collisionBoundary", "collisionPadding", "sticky", "hideWhenDetached", "updatePositionStrategy", "onPlaced"],
  _excluded3 = ["__scopePopper"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { useFloating, autoUpdate, offset, shift, limitShift, hide, arrow as floatingUIarrow, flip, size } from "@floating-ui/react-dom";
import * as ArrowPrimitive from "@radix-ui/react-arrow";
import { useComposedRefs } from "@radix-ui/react-compose-refs";
import { createContextScope } from "@radix-ui/react-context";
import { Primitive } from "@radix-ui/react-primitive";
import { useCallbackRef } from "@radix-ui/react-use-callback-ref";
import { useLayoutEffect } from "@radix-ui/react-use-layout-effect";
import { useSize } from "@radix-ui/react-use-size";
import { jsx } from "react/jsx-runtime";
var SIDE_OPTIONS = ["top", "right", "bottom", "left"];
var ALIGN_OPTIONS = ["start", "center", "end"];
var POPPER_NAME = "Popper";
var _createContextScope = createContextScope(POPPER_NAME),
  _createContextScope2 = _slicedToArray(_createContextScope, 2),
  createPopperContext = _createContextScope2[0],
  createPopperScope = _createContextScope2[1];
var _createPopperContext = createPopperContext(POPPER_NAME),
  _createPopperContext2 = _slicedToArray(_createPopperContext, 2),
  PopperProvider = _createPopperContext2[0],
  usePopperContext = _createPopperContext2[1];
var Popper = function Popper(props) {
  var __scopePopper = props.__scopePopper,
    children = props.children;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    anchor = _React$useState2[0],
    setAnchor = _React$useState2[1];
  return /* @__PURE__ */jsx(PopperProvider, {
    scope: __scopePopper,
    anchor: anchor,
    onAnchorChange: setAnchor,
    children: children
  });
};
Popper.displayName = POPPER_NAME;
var ANCHOR_NAME = "PopperAnchor";
var PopperAnchor = React.forwardRef(function (props, forwardedRef) {
  var __scopePopper = props.__scopePopper,
    virtualRef = props.virtualRef,
    anchorProps = _objectWithoutProperties(props, _excluded);
  var context = usePopperContext(ANCHOR_NAME, __scopePopper);
  var ref = React.useRef(null);
  var composedRefs = useComposedRefs(forwardedRef, ref);
  React.useEffect(function () {
    context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
  });
  return virtualRef ? null : /* @__PURE__ */jsx(Primitive.div, _objectSpread(_objectSpread({}, anchorProps), {}, {
    ref: composedRefs
  }));
});
PopperAnchor.displayName = ANCHOR_NAME;
var CONTENT_NAME = "PopperContent";
var _createPopperContext3 = createPopperContext(CONTENT_NAME),
  _createPopperContext4 = _slicedToArray(_createPopperContext3, 2),
  PopperContentProvider = _createPopperContext4[0],
  useContentContext = _createPopperContext4[1];
var PopperContent = React.forwardRef(function (props, forwardedRef) {
  var _arrowSize$width, _arrowSize$height, _middlewareData$arrow, _middlewareData$arrow2, _middlewareData$arrow3, _middlewareData$trans, _middlewareData$trans2, _middlewareData$hide;
  var __scopePopper = props.__scopePopper,
    _props$side = props.side,
    side = _props$side === void 0 ? "bottom" : _props$side,
    _props$sideOffset = props.sideOffset,
    sideOffset = _props$sideOffset === void 0 ? 0 : _props$sideOffset,
    _props$align = props.align,
    align = _props$align === void 0 ? "center" : _props$align,
    _props$alignOffset = props.alignOffset,
    alignOffset = _props$alignOffset === void 0 ? 0 : _props$alignOffset,
    _props$arrowPadding = props.arrowPadding,
    arrowPadding = _props$arrowPadding === void 0 ? 0 : _props$arrowPadding,
    _props$avoidCollision = props.avoidCollisions,
    avoidCollisions = _props$avoidCollision === void 0 ? true : _props$avoidCollision,
    _props$collisionBound = props.collisionBoundary,
    collisionBoundary = _props$collisionBound === void 0 ? [] : _props$collisionBound,
    _props$collisionPaddi = props.collisionPadding,
    collisionPaddingProp = _props$collisionPaddi === void 0 ? 0 : _props$collisionPaddi,
    _props$sticky = props.sticky,
    sticky = _props$sticky === void 0 ? "partial" : _props$sticky,
    _props$hideWhenDetach = props.hideWhenDetached,
    hideWhenDetached = _props$hideWhenDetach === void 0 ? false : _props$hideWhenDetach,
    _props$updatePosition = props.updatePositionStrategy,
    updatePositionStrategy = _props$updatePosition === void 0 ? "optimized" : _props$updatePosition,
    onPlaced = props.onPlaced,
    contentProps = _objectWithoutProperties(props, _excluded2);
  var context = usePopperContext(CONTENT_NAME, __scopePopper);
  var _React$useState3 = React.useState(null),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    content = _React$useState4[0],
    setContent = _React$useState4[1];
  var composedRefs = useComposedRefs(forwardedRef, function (node) {
    return setContent(node);
  });
  var _React$useState5 = React.useState(null),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    arrow = _React$useState6[0],
    setArrow = _React$useState6[1];
  var arrowSize = useSize(arrow);
  var arrowWidth = (_arrowSize$width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize$width !== void 0 ? _arrowSize$width : 0;
  var arrowHeight = (_arrowSize$height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize$height !== void 0 ? _arrowSize$height : 0;
  var desiredPlacement = side + (align !== "center" ? "-" + align : "");
  var collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : _objectSpread({
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }, collisionPaddingProp);
  var boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [collisionBoundary];
  var hasExplicitBoundaries = boundary.length > 0;
  var detectOverflowOptions = {
    padding: collisionPadding,
    boundary: boundary.filter(isNotNull),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: hasExplicitBoundaries
  };
  var _useFloating = useFloating({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: desiredPlacement,
      whileElementsMounted: function whileElementsMounted() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        var cleanup = autoUpdate.apply(void 0, args.concat([{
          animationFrame: updatePositionStrategy === "always"
        }]));
        return cleanup;
      },
      elements: {
        reference: context.anchor
      },
      middleware: [offset({
        mainAxis: sideOffset + arrowHeight,
        alignmentAxis: alignOffset
      }), avoidCollisions && shift(_objectSpread({
        mainAxis: true,
        crossAxis: false,
        limiter: sticky === "partial" ? limitShift() : void 0
      }, detectOverflowOptions)), avoidCollisions && flip(_objectSpread({}, detectOverflowOptions)), size(_objectSpread(_objectSpread({}, detectOverflowOptions), {}, {
        apply: function apply(_ref) {
          var elements = _ref.elements,
            rects = _ref.rects,
            availableWidth = _ref.availableWidth,
            availableHeight = _ref.availableHeight;
          var _rects$reference = rects.reference,
            anchorWidth = _rects$reference.width,
            anchorHeight = _rects$reference.height;
          var contentStyle = elements.floating.style;
          contentStyle.setProperty("--radix-popper-available-width", "".concat(availableWidth, "px"));
          contentStyle.setProperty("--radix-popper-available-height", "".concat(availableHeight, "px"));
          contentStyle.setProperty("--radix-popper-anchor-width", "".concat(anchorWidth, "px"));
          contentStyle.setProperty("--radix-popper-anchor-height", "".concat(anchorHeight, "px"));
        }
      })), arrow && floatingUIarrow({
        element: arrow,
        padding: arrowPadding
      }), transformOrigin({
        arrowWidth: arrowWidth,
        arrowHeight: arrowHeight
      }), hideWhenDetached && hide(_objectSpread({
        strategy: "referenceHidden"
      }, detectOverflowOptions))]
    }),
    refs = _useFloating.refs,
    floatingStyles = _useFloating.floatingStyles,
    placement = _useFloating.placement,
    isPositioned = _useFloating.isPositioned,
    middlewareData = _useFloating.middlewareData;
  var _getSideAndAlignFromP = getSideAndAlignFromPlacement(placement),
    _getSideAndAlignFromP2 = _slicedToArray(_getSideAndAlignFromP, 2),
    placedSide = _getSideAndAlignFromP2[0],
    placedAlign = _getSideAndAlignFromP2[1];
  var handlePlaced = useCallbackRef(onPlaced);
  useLayoutEffect(function () {
    if (isPositioned) {
      handlePlaced === null || handlePlaced === void 0 || handlePlaced();
    }
  }, [isPositioned, handlePlaced]);
  var arrowX = (_middlewareData$arrow = middlewareData.arrow) === null || _middlewareData$arrow === void 0 ? void 0 : _middlewareData$arrow.x;
  var arrowY = (_middlewareData$arrow2 = middlewareData.arrow) === null || _middlewareData$arrow2 === void 0 ? void 0 : _middlewareData$arrow2.y;
  var cannotCenterArrow = ((_middlewareData$arrow3 = middlewareData.arrow) === null || _middlewareData$arrow3 === void 0 ? void 0 : _middlewareData$arrow3.centerOffset) !== 0;
  var _React$useState7 = React.useState(),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    contentZIndex = _React$useState8[0],
    setContentZIndex = _React$useState8[1];
  useLayoutEffect(function () {
    if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
  }, [content]);
  return /* @__PURE__ */jsx("div", {
    ref: refs.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: _objectSpread(_objectSpread({}, floatingStyles), {}, _defineProperty({
      transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: contentZIndex
    }, "--radix-popper-transform-origin", [(_middlewareData$trans = middlewareData.transformOrigin) === null || _middlewareData$trans === void 0 ? void 0 : _middlewareData$trans.x, (_middlewareData$trans2 = middlewareData.transformOrigin) === null || _middlewareData$trans2 === void 0 ? void 0 : _middlewareData$trans2.y].join(" ")), ((_middlewareData$hide = middlewareData.hide) === null || _middlewareData$hide === void 0 ? void 0 : _middlewareData$hide.referenceHidden) && {
      visibility: "hidden",
      pointerEvents: "none"
    }),
    dir: props.dir,
    children: /* @__PURE__ */jsx(PopperContentProvider, {
      scope: __scopePopper,
      placedSide: placedSide,
      onArrowChange: setArrow,
      arrowX: arrowX,
      arrowY: arrowY,
      shouldHideArrow: cannotCenterArrow,
      children: /* @__PURE__ */jsx(Primitive.div, _objectSpread(_objectSpread({
        "data-side": placedSide,
        "data-align": placedAlign
      }, contentProps), {}, {
        ref: composedRefs,
        style: _objectSpread(_objectSpread({}, contentProps.style), {}, {
          // if the PopperContent hasn't been placed yet (not all measurements done)
          // we prevent animations so that users's animation don't kick in too early referring wrong sides
          animation: !isPositioned ? "none" : void 0
        })
      }))
    })
  });
});
PopperContent.displayName = CONTENT_NAME;
var ARROW_NAME = "PopperArrow";
var OPPOSITE_SIDE = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
};
var PopperArrow = React.forwardRef(function PopperArrow2(props, forwardedRef) {
  var __scopePopper = props.__scopePopper,
    arrowProps = _objectWithoutProperties(props, _excluded3);
  var contentContext = useContentContext(ARROW_NAME, __scopePopper);
  var baseSide = OPPOSITE_SIDE[contentContext.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */
    jsx("span", {
      ref: contentContext.onArrowChange,
      style: _defineProperty(_defineProperty(_defineProperty(_defineProperty({
        position: "absolute",
        left: contentContext.arrowX,
        top: contentContext.arrowY
      }, baseSide, 0), "transformOrigin", {
        top: "",
        right: "0 0",
        bottom: "center 0",
        left: "100% 0"
      }[contentContext.placedSide]), "transform", {
        top: "translateY(100%)",
        right: "translateY(50%) rotate(90deg) translateX(-50%)",
        bottom: "rotate(180deg)",
        left: "translateY(50%) rotate(-90deg) translateX(50%)"
      }[contentContext.placedSide]), "visibility", contentContext.shouldHideArrow ? "hidden" : void 0),
      children: /* @__PURE__ */jsx(ArrowPrimitive.Root, _objectSpread(_objectSpread({}, arrowProps), {}, {
        ref: forwardedRef,
        style: _objectSpread(_objectSpread({}, arrowProps.style), {}, {
          // ensures the element can be measured correctly (mostly for if SVG)
          display: "block"
        })
      }))
    })
  );
});
PopperArrow.displayName = ARROW_NAME;
function isNotNull(value) {
  return value !== null;
}
var transformOrigin = function transformOrigin(options) {
  return {
    name: "transformOrigin",
    options: options,
    fn: function fn(data) {
      var _middlewareData$arrow4, _middlewareData$arrow5, _middlewareData$arrow6, _middlewareData$arrow7, _middlewareData$arrow8;
      var placement = data.placement,
        rects = data.rects,
        middlewareData = data.middlewareData;
      var cannotCenterArrow = ((_middlewareData$arrow4 = middlewareData.arrow) === null || _middlewareData$arrow4 === void 0 ? void 0 : _middlewareData$arrow4.centerOffset) !== 0;
      var isArrowHidden = cannotCenterArrow;
      var arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
      var arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
      var _getSideAndAlignFromP3 = getSideAndAlignFromPlacement(placement),
        _getSideAndAlignFromP4 = _slicedToArray(_getSideAndAlignFromP3, 2),
        placedSide = _getSideAndAlignFromP4[0],
        placedAlign = _getSideAndAlignFromP4[1];
      var noArrowAlign = {
        start: "0%",
        center: "50%",
        end: "100%"
      }[placedAlign];
      var arrowXCenter = ((_middlewareData$arrow5 = (_middlewareData$arrow6 = middlewareData.arrow) === null || _middlewareData$arrow6 === void 0 ? void 0 : _middlewareData$arrow6.x) !== null && _middlewareData$arrow5 !== void 0 ? _middlewareData$arrow5 : 0) + arrowWidth / 2;
      var arrowYCenter = ((_middlewareData$arrow7 = (_middlewareData$arrow8 = middlewareData.arrow) === null || _middlewareData$arrow8 === void 0 ? void 0 : _middlewareData$arrow8.y) !== null && _middlewareData$arrow7 !== void 0 ? _middlewareData$arrow7 : 0) + arrowHeight / 2;
      var x = "";
      var y = "";
      if (placedSide === "bottom") {
        x = isArrowHidden ? noArrowAlign : "".concat(arrowXCenter, "px");
        y = "".concat(-arrowHeight, "px");
      } else if (placedSide === "top") {
        x = isArrowHidden ? noArrowAlign : "".concat(arrowXCenter, "px");
        y = "".concat(rects.floating.height + arrowHeight, "px");
      } else if (placedSide === "right") {
        x = "".concat(-arrowHeight, "px");
        y = isArrowHidden ? noArrowAlign : "".concat(arrowYCenter, "px");
      } else if (placedSide === "left") {
        x = "".concat(rects.floating.width + arrowHeight, "px");
        y = isArrowHidden ? noArrowAlign : "".concat(arrowYCenter, "px");
      }
      return {
        data: {
          x: x,
          y: y
        }
      };
    }
  };
};
function getSideAndAlignFromPlacement(placement) {
  var _placement$split = placement.split("-"),
    _placement$split2 = _slicedToArray(_placement$split, 2),
    side = _placement$split2[0],
    _placement$split2$ = _placement$split2[1],
    align = _placement$split2$ === void 0 ? "center" : _placement$split2$;
  return [side, align];
}
var Root2 = Popper;
var Anchor = PopperAnchor;
var Content = PopperContent;
var Arrow = PopperArrow;
export { ALIGN_OPTIONS, Anchor, Arrow, Content, Popper, PopperAnchor, PopperArrow, PopperContent, Root2 as Root, SIDE_OPTIONS, createPopperScope };